import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { offer } from '../data/offer';
const HERO_BG = 'https://cdn.magicpatterns.com/patterns/generated-images/114e7f7c-b720-45ba-a9d4-04559571f636.jpg';
const BUNDLE = 'https://cdn.magicpatterns.com/patterns/generated-images/7c87cbfb-8768-40a4-91ec-b470735828d0.jpg';
interface HeroProps {
  variant: 'stadium' | 'bundle';
}
const rise = {
  hidden: {
    opacity: 0,
    y: 18
  },
  visible: {
    opacity: 1,
    y: 0
  }
};
const ease = [0.23, 1, 0.32, 1] as const;
function TrustRow() {
  return <ul className="flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-white/70" style={{
    paddingTop: "0px",
    paddingBottom: "0px"
  }} data-id="element-83" data-mp="s9gfzxf9kc74">
      <li className="flex items-center gap-2" data-id="element-84" data-mp="3d21rlvg2wgmo">
        <span className="flex" aria-hidden="true" data-id="element-85" data-mp="3d2torapbqmf2">
          {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-sun text-sun" data-id="element-86" data-mp="381e6fqej6u0d" />)}
        </span>
        <span data-id="element-87" data-mp="3j898df6ywfql">
          <span className="font-semibold text-white" data-id="element-88" data-mp="3j9u1d0dmvqmc">{offer.satisfaction}</span> সন্তুষ্টির হার
        </span>
      </li>
      <li className="flex items-center gap-2" data-id="element-89" data-mp="3o6u8lem7yzf1">
        <CheckCircle2Icon className="h-4 w-4 text-celeste-400" aria-hidden="true" data-id="element-90" data-mp="39auqdb5ebiw6" />
        বাংলাদেশের {offer.studentCount} শিক্ষার্থী
      </li>
      <li className="flex items-center gap-2" data-id="element-91" data-mp="3e7uxlpdzerov">
        <CheckCircle2Icon className="h-4 w-4 text-celeste-400" aria-hidden="true" data-id="element-92" data-mp="30iaxysfp6ajs" />
        ৭ দিনের মানি-ব্যাক গ্যারান্টি
      </li>
    </ul>;
}
function HeroCopy({
  centered
}: {
  centered: boolean;
}) {
  return <motion.div initial="hidden" animate="visible" transition={{
    staggerChildren: 0.06
  }} className={centered ? 'max-w-4xl' : 'max-w-xl'} data-id="element-93" data-mp="2qkdai75nwhs8">
      <motion.p variants={rise} transition={{
      duration: 0.28,
      ease
    }} className="text-[11px] font-semibold uppercase tracking-[0.22em] text-celeste-400" style={{
      fontSize: "16px",
      paddingTop: "0px",
      paddingBottom: "0px",
      textAlign: "center"
    }} data-id="element-94" data-mp="2vj7uhcfd8cdx">
          KODA ☀ DIGITAL
      </motion.p>

      <motion.h1 variants={rise} transition={{
      duration: 0.32,
      ease
    }} className="mt-5 font-display text-[2.15rem] font-extrabold leading-[1.03] tracking-tight text-white sm:text-5xl lg:text-[3.5rem]" data-id="element-95" data-mp="s3cmgcr3vnrm">
        <span className="block text-celeste-400" data-id="element-96" data-mp="i9vpizvo9sjq">দুই দেশ, এক আত্মা:</span>
        <span className="block text-celeste-400" data-id="element-97" data-mp="deq4e3a3ghwp">সেই গোপন মাইন্ডসেট</span>
        <span className="block text-white" data-id="element-98" data-mp="1azumrik0svzh">যা কষ্টকে বদলে দেয়</span>
        <span className="block text-white" style={{
        paddingTop: "0px",
        paddingBottom: "0px"
      }} data-id="element-99" data-mp="1622jjsdxdnfz">বিশ্বজয়ী সাফল্যে</span>
        <span className="mt-4 block text-[1.3rem] font-bold leading-snug text-celeste-400 sm:text-3xl lg:text-[2rem]" data-id="element-100" data-mp="111yagnfcjuzs">
          <span className="block" style={{
          paddingTop: "0px",
          paddingBottom: "0px",
          marginTop: "0px",
          marginBottom: "0px"
        }} data-id="element-101" data-mp="x0csinnygqiq">দশকের পর দশক আর্জেন্টিনা ও বাংলাদেশ</span>
          <span className="block" data-id="element-102" data-mp="3hqu2ybi9aa1p">একেবারে তলা থেকে লড়ে এসেছে।</span>
        </span>
      </motion.h1>

      <motion.figure variants={rise} transition={{
      duration: 0.32,
      ease
    }} className="mx-auto mt-8 w-full max-w-sm sm:max-w-md lg:max-w-lg" data-id="element-103" data-mp="1x9ulmd6nbhoh">
        <img src="https://cdn.magicpatterns.com/uploads/1F54PG35zgk9PPm7PMfsdP/hf_20260828_232444_4091d97d-8cc8-4515-9b4a-3185bb5c24c9.png" alt="দ্য আর্জেন্টাইন মাইন্ডসেট সম্পূর্ণ ডিজিটাল সিস্টেম: ছয়টি ভলিউম, মূল বই, বোনাস কালেকশন এবং ট্যাব ও ফোনে দেখানো কনটেন্ট — বুয়েনস আইরেস ও ঢাকার রাতের স্কাইলাইনের পটভূমিতে" className="w-full rounded-xl border border-white/15" style={{
        paddingTop: "0px",
        paddingBottom: "0px",
        marginTop: "0px",
        marginBottom: "0px"
      }} data-id="element-104" data-mp="218tprvkjzaev" />
      </motion.figure>

      <motion.p variants={rise} transition={{
      duration: 0.32,
      ease
    }} className="mt-6 max-w-2xl text-lg leading-relaxed text-white/75 sm:text-xl" style={{
      fontSize: "14px",
      paddingTop: "0px",
      paddingBottom: "0px",
      marginTop: "9px",
      marginBottom: "9px",
      width: "328px",
      height: "120px"
    }} data-id="element-105" data-mp="2p10imkr2kz9j">
        আবিষ্কার করুন সেই নির্দিষ্ট মাইন্ডসেট পরিবর্তন, যা আর্জেন্টিনাকে দারিদ্র্য থেকে
        বিশ্বচ্যাম্পিয়ন বানিয়েছে — আর <span className="font-semibold text-white" data-id="element-106" data-mp="4dgwkrl5hh6j">আজই</span> কীভাবে
        সেটি আপনার ব্যবসা, ফ্রিল্যান্স ক্যারিয়ার বা ব্যক্তিগত উন্নতিতে কাজে লাগাবেন (আগে
        ব্যর্থ হলেও)।
      </motion.p>

      <motion.div variants={rise} transition={{
      duration: 0.32,
      ease
    }} className="mt-9" data-id="element-107" data-mp="e7ha9huhzuqv">
        <CtaButton size="lg" href="#volumes" label="আমি পুরো কনটেন্ট দেখতে চাই" sublabel="সাথে সাথেই অ্যাক্সেস · ৭ দিনের মানি-ব্যাক গ্যারান্টি" data-id="element-108" data-mp="98mi3pan4tu3" />
      </motion.div>

      <motion.div variants={rise} transition={{
      duration: 0.32,
      ease
    }} className="mt-9 border-t border-white/10 pt-6" style={{
      paddingTop: "0px",
      paddingBottom: "0px"
    }} data-id="element-109" data-mp="3csifxr68kmv7">
        <TrustRow data-id="element-110" data-mp="3mnslgovufcdq" />
      </motion.div>
    </motion.div>;
}
export function Hero({
  variant
}: HeroProps) {
  if (variant === 'bundle') {
    return <header className="relative overflow-hidden bg-navy-950" data-id="element-111" data-mp="2u0po402wl7p2">
        <div className="mx-auto grid max-w-content items-center gap-14 px-4 py-20 sm:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:py-28" data-id="element-112" data-mp="2u0fy4chuz0jd">
          <HeroCopy centered={false} data-id="element-113" data-mp="1e9dqblh975xh" />
          <div className="relative" data-id="element-114" data-mp="1eafbiirzh8sx">
            <img src={BUNDLE} alt="The six volumes of The Argentine Mindset shown as ebook covers and on a tablet" className="relative w-full rounded-2xl border border-white/10 object-cover" data-id="element-115" data-mp="1ebgnqqkqk1c8" />
          </div>
        </div>
      </header>;
  }
  return <header className="relative isolate overflow-hidden bg-navy-950" data-id="element-116" data-mp="1s8n7ooh74631">
      <img src={HERO_BG} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-80" data-id="element-117" data-mp="1s7by2812k440" />
      <div className="absolute inset-0 bg-navy-950/55" aria-hidden="true" data-id="element-118" data-mp="1j901zqhfoe46" />
      <div className="relative mx-auto max-w-content px-4 py-24 sm:px-6 lg:py-32" style={{
      paddingTop: "8px",
      paddingBottom: "8px"
    }} data-id="element-119" data-mp="1jat7v3k82ub4">
        <HeroCopy centered data-id="element-120" data-mp="7t1y01144i9t" />
      </div>
    </header>;
}